import React from "react"
import PlayButton from "images/inline/gallery/play-button.svg"
import Modal from "@material-ui/core/Modal"
import Backdrop from "@material-ui/core/Backdrop"
import ShareIcons from "components/ShareIcons"
import VideoPlayer from "./VideoPlayer"
import analytics from "global/AnalyticsData"
import "./gallery-modal.scss"



const getitemType = (uploadFile) => {
  //default itemType
  let mediaType = "photo"
  let videoArray = ["mov", "mp4", "avi", "MOV", "MP4", "AVI"]

  if (videoArray.includes(("." + uploadFile).split(".").pop())) {
    mediaType="video"
  }
  return mediaType
}

const GalleryModal = ({ isModalOpen = false, item = {}, userCanVote=false, onVoteClick=()=>{}, onCloseModalClick=()=>{},  zeroVotesCopy=""}) => {
  const itemType = getitemType(item.uploadFile)

  const handleShareLink = (platform, link) => {

    analytics.stepEvent('step_interaction_gallery_step_social_share',  {
      "platform": platform,
      "link": link,
      "item_shared_id": item.id
    })

  }

  return (
    <Modal
      tabIndex={0}
      className={"0"}
      open={isModalOpen}
      onBackdropClick={() => {
        onCloseModalClick()
      }}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}>
      <div className={`gallery-step-modal gallery-new-modal on`}>
        <div className="gallery-modal-container">
          <div className="gallery-modal__columns">
            {item && (
              <>
                <div className="gallery-modal__column-left">
                  <div className="gallery-modal__media-container">
                    {(itemType === "photo") && <img src={`${process.env.SITE_ASSET_URL}/${item.uploadFile}`} className="gallery-item__image" />}
                    {(itemType === "video") && <VideoPlayer videoURL={`${process.env.SITE_ASSET_URL}/${item.uploadFile}`} />}
                    {itemType === "video" && (
                      <div className="gallery-item__video-button">
                        <PlayButton />
                      </div>
                    )}
                    {(itemType === "photo") && <div className="gallery-modal__media-gradient"></div>}
                  </div>
                </div>
                <div className="gallery-modal__column-right">
                  <h3 className="gallery-modal__column-title">{item.title && item.title}</h3>

                  <div className="gallery-modal__content">{item.caption ? `${item.caption}` : ""}</div>

                  <div className="gallery-modal__submitter">Submitted by: {item.firstName}</div>
                  <div className="gallery-modal__votes">{(item.voteCount === 0) ? zeroVotesCopy : `${item.voteCount} votes`}</div>
                  <div className="gallery-modal__vote-button">
                    <button className={userCanVote ? "btn themed-button" : "btn themed-secondary"} disabled={userCanVote ? false : true} onClick={() => onVoteClick(item.id)}>
                      {userCanVote ? `Vote` : `Your Vote is In`}
                    </button>
                  </div>
                  <div className="gallery-modal__social">
                    <ShareIcons onShareClick={handleShareLink} facebookShare={true} whatsappShare={true} pinterestShare={true} emailShare={true} twitterShare={true} isText={true} shareUrl={item.shareUrl} />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <button
          className={`modal-close top-level-close`}
          onClick={() => {
            onCloseModalClick()
          }}
          aria-label="Close"></button>
      </div>
    </Modal>
  )
}

export default GalleryModal